import { DateTime } from 'luxon'
import {
  PASSWORD_VERIFICATION_CHECK,
  PASSWORD_VERIFICATION_CHECK_FAILURE,
  PASSWORD_VERIFICATION_CHECK_SUCCESS,
  PASSWORD_VERIFICATION_CHECK_LOGIN,
  PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE,
  PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS,
} from './constants'

export type PasswordVerificationActionTypes =
  | PasswordVerificationCheckAction
  | PasswordVerificationSuccessAction
  | PasswordVerificationFailureAction
  | PasswordVerificationLoginAction
  | PasswordVerificationLoginSuccessAction
  | PasswordVerificationLoginFailureAction

export interface PasswordVerificationCheckAction extends Action {
  type: typeof PASSWORD_VERIFICATION_CHECK
  tournamentId: number
}

export interface PasswordVerificationSuccessAction extends Action {
  type: typeof PASSWORD_VERIFICATION_CHECK_SUCCESS
  payload: {
    tournamentId: number
    tournamentName: string
    startTime: DateTime
    courseName: string
    passwordVerification: boolean
  }
}

export interface PasswordVerificationFailureAction extends Action {
  type: typeof PASSWORD_VERIFICATION_CHECK_FAILURE
  tournamentId: number
  error: ErrorPayload
}

export const getPasswordVerificationCheck = (tournamentId: number): PasswordVerificationCheckAction => ({
  type: PASSWORD_VERIFICATION_CHECK,
  tournamentId,
})

export interface PasswordVerificationLoginAction extends Action {
  type: typeof PASSWORD_VERIFICATION_CHECK_LOGIN
  tournamentId: number
  password: string
}

export interface PasswordVerificationLoginSuccessAction extends Action {
  type: typeof PASSWORD_VERIFICATION_CHECK_LOGIN_SUCCESS
  tournamentId: number
}

export interface PasswordVerificationLoginFailureAction extends Action {
  type: typeof PASSWORD_VERIFICATION_CHECK_LOGIN_FAILURE
  tournamentId: number
  error: ErrorPayload
}

export const getPasswordVerificationLogin = (
  tournamentId: number,
  password: string,
): PasswordVerificationLoginAction => ({
  type: PASSWORD_VERIFICATION_CHECK_LOGIN,
  tournamentId,
  password,
})
